import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbtnComponent } from './navbtn.component';
import { NavbtnRoutingModule } from './navbtn-routing.module';


@NgModule({
  declarations: [NavbtnComponent],
  imports: [
    CommonModule,NavbtnRoutingModule
  ], exports: [NavbtnComponent]
})
export class NavbtnModule { }
